var _style, _path, _path2, _path3, _g, _defs, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 631",
    style: {
      enableBackground: "new 0 0 1000 631"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434189;}\n\t.st1{opacity:0.3;fill:#434189;enable-background:new    ;}\n\t.st2{opacity:0.2;fill:#434189;enable-background:new    ;}\n\t.st3{clip-path:url(#SVGID_00000138542757756910184600000003340408762034091952_);}\n\t.st4{fill:none;stroke:#434189;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#434189;stroke:#434189;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#434189;stroke-width:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M964.8,5C981.4,5,995,18.6,995,35.2v560.2c0,16.7-13.6,30.2-30.2,30.2H35.2C18.6,625.6,5,612,5,595.4V35.2 C5,18.6,18.6,5,35.2,5H964.8z M964.8,0H35.2C15.8,0,0,15.8,0,35.2v560.2c0,19.4,15.8,35.2,35.2,35.2h929.6 c19.4,0,35.2-15.8,35.2-35.2V35.2C1000,15.8,984.2,0,964.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M668,430H94.7c-5.6,0-10.2-4.6-10.2-10.2l0,0c0-5.6,4.6-10.2,10.2-10.2H668c5.6,0,10.2,4.6,10.2,10.2l0,0 C678.2,425.5,673.6,430,668,430z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M409.3,494H94.7c-5.6,0-10.2-4.6-10.2-10.2l0,0c0-5.6,4.6-10.2,10.2-10.2h314.6c5.6,0,10.2,4.6,10.2,10.2l0,0 C419.5,489.5,414.9,494,409.3,494z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M740.7,53.7h181.2c4.4,0,7.9,3.5,7.9,7.9v181.2c0,4.4-3.5,7.9-7.9,7.9H740.7c-4.4,0-7.9-3.5-7.9-7.9V61.6 C732.8,57.2,736.4,53.7,740.7,53.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115515394311064631010000012233432015213298322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000115515394311064631010000012233432015213298322_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M810.9,194.5c-23.2,0-41.9-18.8-41.9-42.1v-17.5c0-34.9,28.2-63.1,62.9-63.1c34.7,0,62.9,28.3,62.9,63.1v17.5 c0,23.2-18.8,42.1-41.9,42.1H810.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M786.4,120.9l10.5,42.1c19.3,19.4,50.6,19.4,69.9,0l10.5-42.1C849.2,109.2,816.7,108.3,786.4,120.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M852.8,194.5h-41.9c-5.7,0-11.1-1.1-16.1-3.2l3.3,17.8c9.8,6.2,21.3,9.9,33.7,9.9c12.4,0,24-3.7,33.7-9.9 l3.3-17.8C864,193.4,858.5,194.5,852.8,194.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M845.9,240.1h14c7.7,0,14,6.3,14,14v42.1h-28V240.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M845.9,240.1h-41.9c-7.7,0-14,6.3-14,14v42.1h55.9V240.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M756.5,226.5l-2.6,1.1c-7.1,3-13.6,11.6-14.5,19.3l-5.5,35.4c0,0,7.5,0,14.8,0c7.3,0,16.4,3.2,20.2,7 c3.8,3.8,7,7,7,7h14V260L756.5,226.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M907.2,226.5l2.6,1.1c7.1,3,13.6,11.6,14.5,19.3l5.4,35.4c0,0-7.5,0-14.8,0c-7.3,0-16.4,3.2-20.2,7 c-3.8,3.8-7,7-7,7h-14V260L907.2,226.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M809.7,240.1h-5.8c-7.7,0-14,6.3-14,14v5.8l-33.4-33.5l28-11.6L809.7,240.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M873.8,260v-5.8c0-7.8-6.3-14-14-14H854l25.2-25.3l28,11.6L873.8,260z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M809.7,240.1H854l25.2-25.3l-13.6-5.7c-9.8,6.2-21.3,9.9-33.8,9.9c-12.4,0-24-3.7-33.7-9.9l-13.6,5.7 L809.7,240.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M752.5,56.6h157.5c9.2,0,16.7,7.5,16.7,16.7v157.5c0,9.2-7.5,16.7-16.7,16.7H752.5c-9.2,0-16.7-7.5-16.7-16.7 V73.4C735.8,64.1,743.3,56.6,752.5,56.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCard);
export default __webpack_public_path__ + "static/media/personal_card.e5ad9e05759e5e158e03329f0577ec79.svg";
export { ForwardRef as ReactComponent };